import axios from 'axios';

const samlAuth = async(authPaths) => {
  let loginResponse = {};
  try {
    const samlVerifyResponse = await axios.get(authPaths.authPath, {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      },
    });
    // Check if user is SAML Authenticated
    if (samlVerifyResponse.data && samlVerifyResponse.data.authenticated === true) {
      Object.assign(loginResponse, {
        statusCode: samlVerifyResponse.status,
        data: samlVerifyResponse.data,
      })
      return loginResponse;
    }
    else {
      // If not then redirect them to SAML login page
      window.location = authPaths.loginPath;
    }
  } catch(e) {
    return Object.assign(loginResponse, {
      statusCode: e?.response?.status,
      data: null,
    })
  }
}

export default samlAuth;
